import { OrderBig } from "@chordcommerce/react-autonomy";
import { ChordOrder, ChordResponsiveImage } from "../types/chord.types";

export const toChordOrder = (
  order: Partial<OrderBig>,
): ChordOrder<ChordResponsiveImage> => ({
  ...order,
  lineItems: order.lineItems.map((lineItem) => ({
    ...lineItem,
    variant: {
      ...lineItem.variant,
      images: lineItem.variant.images.map((image) => ({
        desktop: {
          altText: image.alt ?? "",
          src: image.smallUrl,
        },
        mobile: {
          altText: image.alt ?? "",
          src: image.miniUrl,
        },
      })),
    },
  })),
});
